/**
 *
 * CommunicationCopyAudience
 *
 */

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

import { useParams, useLocation } from 'react-router-dom';

// antd component
import { Input } from 'antd';

// components
import TCFModal from 'components/TCFModal';
import { NotificationSimple } from 'components/Notifications';

import api, { setAuthorizationHeader } from 'utils/apis/axiosAPI';
// hooks
import { useAsync, useRefState } from 'utils/hooks';
import { truncate } from 'lodash';

function CommunicationCopyAudience({
  open,
  // actions
  setOpen,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('copy-audience-wrapper', className);

  const { id: initId } = useParams();

  const { isLoading, isSuccess, run, data, reset } = useAsync();

  const newKey = 'nouvel';
  
  const currentUser = JSON.parse(localStorage.getItem('schoolinked_user'));
  setAuthorizationHeader(currentUser?.token);

  const [showError, setShowError] = useState(false);
  const [initialID, setInitialID] = useState(false);
  const [name, setCurrenName] = useState('');

  // Because history not trigger update component
  useEffect(() => {
    if (!!initId && initId != newKey) {
      setInitialID(initId);
    }
  }, [initId]);

  const onChangeName = useCallback(e => {
    const value = e?.target?.value;
    setCurrenName(value);
    if (value?.length <= 5) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, []);

  const NameFiled = useMemo(
    () => (
      <div className="audience-title-wrapper">
        <Input
          value={name || ''}
          placeholder="Nom de l’audience"
          disabled={isLoading}
          onChange={onChangeName}
        />
        {showError && (
          <span className="error">
            Le champ du nom est un champ obligatoire, minimum 6 caractères
          </span>
        )}
      </div>
    ),
    [name, isLoading, showError],
  );

  const onCancelModalHandler = useCallback(() => {
    setCurrenName('');
    !!setOpen && setOpen(false);
  }, [setOpen]);

  const onAddElementHandler = useCallback(() => {
    if (!showError && name?.length > 5) {
      setShowError(false);
      !isLoading &&
        run(
          api.communications.createAudienceFromComm(initialID, {
            title: name,
          }),
        );
      !!setOpen && setOpen(false);
    } else {
      setShowError(true);
    }
  }, [name, initialID, setOpen, isLoading, showError, setShowError]);

  return (
    <>
      <NotificationSimple
        Loading={isLoading}
        Successful={isSuccess}
        message="Enregistré!"
        messageSuccess="Audience sauvegardée!"
        description=""
      />
      <TCFModal
        className={childClassNames}
        open={open}
        setOpen={setOpen}
        title="Nom de l’audience"
        submitName="Sauvegarder l’audience"
        loading={isLoading}
        confirmLoading={isSuccess}
        onCancel={onCancelModalHandler}
        onOk={onAddElementHandler}
      >
        {NameFiled}
      </TCFModal>
    </>
  );
}

CommunicationCopyAudience.defaultProps = {
  open: false,
  loading: false,
  confirmLoading: false,
};

export default CommunicationCopyAudience;
